/**
 * UrbanPaw — Google Reviews Slider
 * Reviews are rendered server-side via Liquid blocks.
 * This script only initializes the Embla carousel.
 */

(function () {
  'use strict';

  function initSlider(section) {
    var viewport = section.querySelector('.gr-embla');
    var prevBtn  = section.querySelector('.gr-btn--prev');
    var nextBtn  = section.querySelector('.gr-btn--next');
    var dotsWrap = section.querySelector('.gr-dots');

    if (!viewport) return;

    if (window.EmblaCarousel) {
      var embla = window.EmblaCarousel(viewport, {
        loop         : true,
        align        : 'start',
        slidesToScroll: 1,
        dragFree     : false,
      });

      // Build dots
      embla.slideNodes().forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'gr-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Review ' + (i + 1));
        dot.addEventListener('click', function () { embla.scrollTo(i); });
        if (dotsWrap) dotsWrap.appendChild(dot);
      });

      function updateDots() {
        var idx = embla.selectedScrollSnap();
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.gr-dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        }
      }
      embla.on('select', updateDots);

      if (prevBtn) prevBtn.addEventListener('click', function () { embla.scrollPrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { embla.scrollNext(); });

      // Auto-play: 6 s, pause on hover/touch, and only while the carousel is
      // actually in the viewport (an offscreen interval wastes main-thread
      // time and hurts INP). Skipped when the user prefers reduced motion.
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoTimer = null;
      var inView = false;
      var pointerOver = false;
      function syncAuto() {
        clearInterval(autoTimer);
        autoTimer = null;
        if (reduceMotion || !inView || pointerOver) return;
        autoTimer = setInterval(function () { embla.scrollNext(); }, 6000);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          syncAuto();
        }, { threshold: 0.25 }).observe(viewport);
      } else {
        inView = true;
        syncAuto();
      }
      // pointer events cover mouse, touch and pen (mouseenter/leave miss touch)
      viewport.addEventListener('pointerenter', function () { pointerOver = true; syncAuto(); });
      viewport.addEventListener('pointerleave', function () { pointerOver = false; syncAuto(); });

    } else {
      // Simple fallback scroll
      var container = viewport.querySelector('.gr-embla__container');
      var slideW = container && container.firstElementChild ? container.firstElementChild.offsetWidth + 16 : 320;
      if (prevBtn) prevBtn.addEventListener('click', function () { viewport.scrollBy({ left: -slideW, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { viewport.scrollBy({ left:  slideW, behavior: 'smooth' }); });
    }
  }

  function init() {
    document.querySelectorAll('.google-reviews-section').forEach(function (section) {
      if (section._grInit) return;
      section._grInit = true;
      initSlider(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.google-reviews-section') || e.target;
    if (section) {
      section._grInit = false;
      initSlider(section);
    }
  });

})();
